import { useEffect, useState } from "react";
import { Download, FileText } from "lucide-react";
import { api } from "../../lib/api";
import { DownloadDialog } from "../forms/DownloadDialog";

export const useFeaturedResource = () => {
  const [res, setRes] = useState(null);
  useEffect(() => {
    api.get("/resources").then((r) => setRes(r.data.find((x) => x.featured) || null)).catch(() => setRes(null));
  }, []);
  return res;
};

export const FeaturedResource = ({ resource }) => {
  if (!resource) return null;
  return (
    <section className="bg-sky text-ink py-20 md:py-24" aria-labelledby="featured-resource-title" data-testid="featured-resource">
      <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-[auto_1fr_auto] gap-8 items-center">
        <div className="w-20 h-24 bg-paper rounded-lg shadow-md grid place-items-center rotate-[-4deg]" aria-hidden="true">
          <FileText className="w-10 h-10 text-teal" />
        </div>
        <div className="min-w-0">
          <p className="lbl text-teal">Free for families & teams</p>
          <h2 id="featured-resource-title" className="font-display mt-3 !text-3xl md:!text-4xl">{resource.title}</h2>
          {resource.description && <p className="mt-3 max-w-2xl text-slate">{resource.description}</p>}
        </div>
        <DownloadDialog resource={resource} idPrefix="home" trigger={
          <button className="inline-flex items-center gap-2 font-sans bg-teal text-paper rounded-full px-7 py-4 hover:bg-teal-deep transition-colors whitespace-nowrap" data-testid="featured-resource-download-button">
            <Download className="w-4 h-4" aria-hidden="true" /> Download it free
          </button>
        } />
      </div>
    </section>
  );
};
